import { DateTime } from 'luxon'
import { AppSelect } from '~/components/new/app-ui/app-select'
import { cn } from '~/lib/utils'

export const periods = ['7-days', '30-days', '6-months', '1-year'] as const
export type Period = (typeof periods)[number]

export const periodDateRanges: Record<Period, () => { start: string; end: string }> = {
  '30-days': () => ({
    start: DateTime.now().minus({ days: 30 }).toISODate(),
    end: DateTime.now().toISODate(),
  }),
  '6-months': () => ({
    start: DateTime.now().minus({ months: 6 }).toISODate(),
    end: DateTime.now().toISODate(),
  }),
  '1-year': () => ({
    start: DateTime.now().minus({ years: 1 }).toISODate(),
    end: DateTime.now().toISODate(),
  }),
  '7-days': () => ({
    start: DateTime.now().minus({ days: 7 }).toISODate(),
    end: DateTime.now().toISODate(),
  }),
}

export interface PeriodOption {
  label: string
  value: Period
}

const periodsOptions: readonly PeriodOption[] = [
  { label: '7 jours', value: '7-days' },
  { label: '30 jours', value: '30-days' },
  { label: '6 mois', value: '6-months' },
  { label: '1 an', value: '1-year' },
]

// Ticket 532 : la période 7 jours du dashboard RH est une fenêtre glissante,
// affichée « 7 JOURS GLISSANTS ». Partagé entre la route planning et la modale Effectif.
export const hrPeriodOptions: readonly PeriodOption[] = [
  { label: '7 JOURS GLISSANTS', value: '7-days' },
  { label: '30 jours', value: '30-days' },
  { label: '6 mois', value: '6-months' },
  { label: '1 an', value: '1-year' },
]

export const PeriodSelect = ({
  period,
  onPeriodChange,
  className,
  options = periodsOptions,
}: {
  className?: string
  period: Period
  onPeriodChange: (period: Period) => void
  // Override the option labels (e.g. the HR dashboard's "7 JOURS GLISSANTS").
  options?: readonly PeriodOption[]
}) => (
  <AppSelect
    className={cn('w-52', className)}
    options={options}
    value={period}
    onChange={(v) => (v ? onPeriodChange(v) : undefined)}
  />
)
